import { ChevronLeft } from 'lucide-react';
import { useEffect, useRef } from 'react';

export function Dialog({
  title,
  onClose,
  children,
  trailing,
  variant = 'screen',
  manageFocus = false,
}: {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  trailing?: React.ReactNode;
  variant?: 'screen' | 'sheet';
  manageFocus?: boolean;
}) {
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    if (!manageFocus) return;
    const previous = document.activeElement instanceof HTMLElement ? document.activeElement : undefined;
    sectionRef.current?.focus();
    return () => { if (previous?.isConnected) previous.focus(); };
  }, [manageFocus]);
  return (
    <div
      className={`dialog-backdrop ${variant}`}
      role="presentation"
      onMouseDown={event => {
        if (variant === 'sheet' && event.target === event.currentTarget) onClose();
      }}
    >
      <section ref={sectionRef} tabIndex={manageFocus ? -1 : undefined} className={`dialog ${variant}`} role="dialog" aria-modal="true" aria-label={title} onKeyDown={event => {
        if (!manageFocus || (event.target as HTMLElement).closest('[role="dialog"]') !== event.currentTarget) return;
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); onClose(); }
        if (event.key !== 'Tab') return;
        const controls = Array.from(event.currentTarget.querySelectorAll<HTMLElement>('button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]')).filter(item => item.offsetParent !== null);
        const first = controls[0]; const last = controls.at(-1);
        if (event.shiftKey && (document.activeElement === first || document.activeElement === event.currentTarget)) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }}>
        <header className="dialog-header">
          {variant === 'screen' && (
            <button className="dialog-back" aria-label="Назад" onClick={onClose}>
              <ChevronLeft size={22} />
            </button>
          )}
          <h2>{title}</h2>
          {variant === 'screen' && (trailing ?? <span />)}
        </header>
        {children}
      </section>
    </div>
  );
}
